const silnik = { t: 'Silnk', name: 'silnk'}
export default silnik